import { gql } from '@apollo/client';
import type { CreateEligibilityWidgetToken } from '../../../types/eligibilityWidget/EligibilityWidgetToken';

export interface CreateEligibilityWidgetTokenRequest {
  pid: string;
  pnr: string;
  lastName: string;
  apiKey: string;
}

export interface CreateEligibilityWidgetTokenResponse {
  createWidgetToken: CreateEligibilityWidgetToken;
}

export const defaultEligibilityWidgetResponse = {
  createWidgetToken: {
    eligible: false,
    segments: [],
  },
};

const CREATE_ELIGIBILITY_WIDGET_TOKEN = gql`
  mutation createEligibilityWidgetToken($pid: String, $pnr: String, $lastName: String, $apiKey: String) {
    createWidgetToken(pid: $pid, pnr: $pnr, lastName: $lastName, apiKey: $apiKey) {
      eligible
      requestId
      channelSource
      language
      currency
      segments {
        journey {
          originCode
          destinationCode
        }
        upgradeTypes {
          upgradeType
          overallStartingPrice
          submitUrl
          textKey
          purchaseModes {
            purchaseMode
            startingPrice
          }
          submittedOffers {
            purchaseMode
            status
            modifyUrl
            cancelUrl
            totalAmount
            actionType
          }
        }
      }
    }
  }
`;

export default CREATE_ELIGIBILITY_WIDGET_TOKEN;
